// extracted by mini-css-extract-plugin
export default {"caption":"PhuHuynhChildList_caption__l7uAP","list_horizontal":"PhuHuynhChildList_list_horizontal__anGaQ","list_horizontal_item":"PhuHuynhChildList_list_horizontal_item__LPHnb"};